import styled from "styled-components";

const AvatarWrapper = styled.div`
    width: 100%;
    aspect-ratio: 1 / 1;
    border-radius: 12px;
    overflow: hidden;
    background-color: rgb(20, 20, 20);
    border: 2px solid rgba(163, 27, 27, 0.5);
    box-shadow: 0 8px 32px rgba(163, 27, 27, 0.2), 0 2px 8px rgba(0,0,0,0.6);

    & img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: top;
        display: block;
    }
`;

function WrestlerAvatar({ wrestlerData }: any) {
    return (
        <AvatarWrapper>
            <img
                src={process.env.REACT_APP_STORAGE_URL + wrestlerData.avatar_path}
                alt={wrestlerData.name}
            />
        </AvatarWrapper>
    );
}

export default WrestlerAvatar;
